import React, {useEffect, useState} from 'react';


export interface LazyImgProps extends React.ImgHTMLAttributes {
    targetRef?: React.LegacyRef,
    readAsBlob?: boolean,
}

function LazyImg({src, targetRef, readAsBlob, style, onLoad, loading, decoding, ...restProps}: LazyImgProps) {

    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        setLoaded(false);
    }, [src]);

    const handleLoad = (event) => {
        setLoaded(true);
        if (onLoad) onLoad(event);
    };

    return (
        <img
            src={src}
            alt={restProps.alt || "THEPLUG COM"}
            loading={loading || "lazy"}
            decoding={decoding || "async"}
            style={{opacity: loaded ? 1 : 0, transition: "opacity 0.3s ease", ...style}}
            {...restProps}
            onLoad={handleLoad}
            ref={targetRef}
        />
    );
}

export default LazyImg;
